module.exports = __webpack_public_path__ + "it.47b1aa54b9571aa8c3ca.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/it.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/it.svg
// module chunks = styles